export default "__VITE_ASSET__BJwyjhqE__"